import { motion } from "framer-motion";
import "./ThankYou.css";

const ThankYou = () => {
  return (
    <div className="thank-you-page">
      <div className="thank-you-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <motion.div
        className="thank-you-container"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.div
          className="thank-you-card"
          initial={{ scale: 0.9 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <div className="icon-container">
            <motion.div
              className="check-circle"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ type: "spring", stiffness: 200, delay: 0.4 }}
            >
              <svg viewBox="0 0 24 24" fill="none" className="check-icon">
                <motion.path
                  d="M9 12.5L11.5 15L15.5 9.5"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  initial={{ pathLength: 0 }}
                  animate={{ pathLength: 1 }}
                  transition={{ duration: 0.5, delay: 0.6 }}
                />
              </svg>
            </motion.div>
          </div>

          <motion.h1
            className="thank-you-heading"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Thank You for Visiting
          </motion.h1>

          <motion.p
            className="thank-you-subtext"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            Our team will get back to you shortly.
          </motion.p>
        </motion.div>

        <motion.p
          className="footer-text"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
        >
          Vercel © {new Date().getFullYear()}
        </motion.p>
      </motion.div>
    </div>
  );
};

export default ThankYou;
